// extracted by mini-css-extract-plugin
module.exports = {"columns":"Columns_columns__rWhU6","one":"Columns_one__1vhJJ","two":"Columns_two__2vZ5z","three":"Columns_three__3m149","four":"Columns_four__20Qfd","five":"Columns_five__149-A"};